(() => {
  const root = document.querySelector('[data-lc]');
  if (!root) return;

  const grid = root.querySelector('[data-lc-grid]');
  if (!grid) return;
  const cards = Array.from(grid.querySelectorAll('[data-lc-card]'));
  const chips = Array.from(root.querySelectorAll('[data-lc-filter]'));
  const sortSelect = root.querySelector('[data-lc-sort]');
  const countEl = root.querySelector('[data-lc-count]');
  const emptyEl = root.querySelector('[data-lc-empty]');
  const shop = root.querySelector('#lc-shop');
  let filter = 'all';

  const compare = {
    featured: (a, b) => a.dataset.index - b.dataset.index,
    'price-asc': (a, b) => a.dataset.price - b.dataset.price,
    'price-desc': (a, b) => b.dataset.price - a.dataset.price,
    save: (a, b) => (b.dataset.save - a.dataset.save) || (a.dataset.index - b.dataset.index)
  };

  const render = () => {
    let visible = 0;
    cards.forEach(card => {
      const show = filter === 'all' || card.dataset.cats.split(' ').includes(filter);
      card.hidden = !show;
      if (show) visible += 1;
    });
    chips.forEach(chip => chip.setAttribute('aria-pressed', String(chip.dataset.lcFilter === filter)));
    if (countEl) countEl.textContent = visible + (visible === 1 ? ' lamp' : ' lamps');
    if (emptyEl) emptyEl.hidden = visible !== 0;
  };

  const sortCards = () => {
    const fn = compare[sortSelect ? sortSelect.value : 'featured'] || compare.featured;
    cards.slice().sort(fn).forEach(card => grid.appendChild(card));
  };

  const setFilter = (next, opts = {}) => {
    if (!chips.some(chip => chip.dataset.lcFilter === next)) next = 'all';
    filter = next;
    render();
    try {
      const url = new URL(window.location.href);
      if (next === 'all') url.searchParams.delete('lamp'); else url.searchParams.set('lamp', next);
      window.history.replaceState(null, '', url);
    } catch (e) { /* ignore */ }
    if (opts.scroll && shop) shop.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  };

  chips.forEach(chip => chip.addEventListener('click', () => setFilter(chip.dataset.lcFilter)));
  root.querySelectorAll('[data-lc-jump]').forEach(btn => btn.addEventListener('click', () => setFilter(btn.dataset.lcJump, { scroll: true })));
  if (sortSelect) sortSelect.addEventListener('change', sortCards);

  try {
    const initial = new URL(window.location.href).searchParams.get('lamp');
    if (initial) setFilter(initial);
  } catch (e) { /* ignore */ }
  render();
})();
